import { render } from "./miscellaneous.vue?vue&type=template&id=3593335e"
import script from "./miscellaneous.vue?vue&type=script&lang=js"
export * from "./miscellaneous.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__